export const searchSettingsStringParams = '?all_selected&cur_focus_id&filter&objectCount&order&path&searchItemIndex&search_page&' +
  'search_result_view&query&selected&targetId&search_engine';

export const searchSettingsParams = {
  all_selected: { type: 'string', raw: true },
  cur_focus_id: { type: 'string', raw: true },
  filter: { type: 'string', raw: true},
  objectCount: { type: 'int', raw: true },
  order: { type: 'string', raw: true },
  path: { type: 'string', raw: true },
  searchItemIndex: { type: 'int', raw: true },
  search_engine: { type: 'string', raw: true },
  search_page: { type: 'int', raw: true },
  search_result_view: { type: 'string', raw: true },
  query: { type: 'string', raw: true },
  selected: { type: 'string', raw: true },
  targetId: { type: 'string', raw: true },
  // template_group_id: { type: 'string', raw: true }
};

export const searchStateParamMapper = {
  all_selected: 'allSelected',
  cur_focus_id: 'curFocusId',
  filter: 'checkedFilters',
  objectCount: 'objectCount',
  order: 'order',
  path: 'path',
  searchItemIndex: 'searchItemIndex',
  search_engine: 'searchEngine',
  search_page: 'searchPage',
  search_result_view: 'searchResultViewName',
  selected: 'selected',
  query: 'query',
  targetId: 'targetId',
  template_group_id: 'templateGroupId'
};
